import { UEStreamingsKeyType } from '../../keys/models/ueStreamings';

const ueStreamingsKeys: UEStreamingsKeyType = {
  openCameraMenu: 'Open camera menu',
  closeCameraMenu: 'Close camera menu',
  cameraSettings: 'Settings',
  enterFullscreen: 'Enter fullscreen',
  exitFullscreen: 'Exit fullscreen',
  exitStudio: 'Exit studio',
  saveCurrentView: 'Save current view',
  aspectRatioPanel: 'Aspect ratio',
  helpNavTitle: 'Navigation',
  helpCaptureTitle: 'Capture & Export',
  helpCameraTitle: 'Saves & Cameras',
  helpSceneTitle: 'Tools',
  helpNavDrag: 'Hold right mouse button and move mouse to look around',
  helpNavScroll: 'Scroll — adjusts movement speed (also movement speed slider)',
  helpNavMove: 'Hold right mouse button and press',
  helpNavHeight: 'up / down',
  helpNavCameraPanel: 'also controllable via Camera Move panel on the left',
  helpCapturePhoto: 'saves the current view as an image',
  helpExportTask: 'sends all scene settings back to the task',
  helpCameraSaveView:
    'saves all scene settings — lights, objects, sun, atmosphere',
  helpCameraLoadView: 'saves current camera position and angle',
  helpSceneSave: 'hides all textures to see the shape of objects',
  helpSceneApply:
    'click any object or light in the scene to select and move it',
  helpSceneUndoRedo: 'cancel or restore the last change of selected object',
  helpSceneFocus: 'focus camera on selected object',
  helpSettingsTitle: 'Scene Settings',
  helpSettingsCamera: 'Camera — lens, focus, depth of field, exposure',
  helpSettingsSun: 'Sun — direction, brightness, color temperature',
  helpSettingsAtm: 'Atmosphere — fog and sky color',
  helpAspectTitle: 'Aspect Ratio',
  helpAspectDesc: 'Set the frame shape before taking a photo',
  helpSavesReset: 'in Saves panel — restores scene to original state',
  helpSavesRestore: 'click any saved scene or camera to restore it',
  helpSavesResetCamera: 'in Cameras panel — restores cameras to original',
  helpAspect16x9: 'landscape',
  helpAspect9x16: 'portrait',
  helpAspect4x3: 'classic',
  helpAspect1x1: 'square',
  helpAspectAuto: 'adapts to viewport',
  helpAspectCustom: 'enter width and height',
  systemSettings: 'Dev settings',
  nanite: 'Nanite',
  deleteSave: 'Delete save',
  deleteSaveActiveWarning:
    'This is the currently active save. After deletion the scene may revert to baseline.',
  deleteCamera: 'Delete camera',
  grayscaleMode: 'Grayscale mode',
  selectionTrace: 'Selection trace',
  undo: 'Undo',
  redo: 'Redo',
  exportSettingsToTask: 'Export settings to task',
  takePicture: 'Take a picture',
  processing: 'Processing...',
  establishingConnection: 'Establishing connection...',
  queuePosition: 'Position {{position}} of {{total}} in queue',
  estimatedWait: 'Estimated wait: ~{{minutes}} min',
  doNotNavigateAway: 'Do not navigate away — leaving resets your position.',
  tryAgain: 'Try again',
  tabCamera: 'Camera',
  tabSun: 'Sun',
  tabAtmosphere: 'Atmosphere',
  tabPostproduction: 'Postproduction',
  tabScene: 'Scene',
  cameraMove: 'Camera move',
  orientation: 'Orientation',
  stepSize: 'Step size',
  panAngle: 'Pan angle',
  tiltAngle: 'Tilt angle',
  interiorLightsScale: 'Interior lights scale',
  sunPosition: 'Sun position',
  sunParameters: 'Sun parameters',
  cameras: 'Cameras',
  noCameras: 'No cameras',
  savedCameras: 'Saved cameras',
  saves: 'Saves',
  noSaves: 'No saves',
  sceneSaves: 'Scene saves',
  saveView: 'Save view',
  showCameraMovePanel: 'Show camera move panel',
  hideCameraMovePanel: 'Hide camera move panel',
  showHidePanels: 'Show/Hide panels',
  hideLists: 'Hide lists',
  showLists: 'Show lists',
  sectionLens: 'Lens',
  sectionDepthOfField: 'Depth of field',
  sectionMovement: 'Movement',
  sectionPerspective: 'Perspective',
  correctionStrength: 'Correction strength',
  focalLength: 'Focal length',
  clippingPlane: 'Clipping plane',
  fStop: 'F-stop',
  focusDistance: 'Focus distance',
  movementSpeed: 'Movement speed',
  rotationSpeed: 'Rotation speed',
  cameraBounds: 'Camera bounds',
  skyLightIntensity: 'Sky light intensity',
  fogDensity: 'Fog density',
  exposure: 'Exposure',
  sunPitch: 'Sun pitch',
  sunYaw: 'Sun yaw',
  sunIntensity: 'Sun intensity',
  sunTemperature: 'Sun temperature',
  sunLightSourceAngle: 'Sun light source angle',
  autoVerticalAlignment: 'Auto vertical alignment',
  sectionExposureAndInterior: 'Exposure & interior',
  sectionSkyAndFog: 'Sky & fog',
  sectionFogColor: 'Fog color',
  sectionMeshes: 'Meshes',
  sectionLights: 'Lights'
};

export default ueStreamingsKeys;
